import { PaymentManagementContainer } from 'modules/PaymentManagement'
import React from 'react'

type Props = {}

const PaymentManagement = (props: Props) => {
    return (
        <PaymentManagementContainer />
    )
}

export default PaymentManagement